import { CertificateOut } from '../types/apiRequests'

export const getKoppelvlak = (record: CertificateOut | undefined): string => {
    if (record?.metaData) {
        return (record.metaData as { interface?: { name: string } }).interface?.name || ''
    }
    return ''
}
